export default __webpack_public_path__ + "static/FY17_Scholarly Report-458ff0275a828e6615e5d9334edef3c7.pdf";